import { FC, HTMLAttributes, ReactNode } from 'react';

interface TableCellProps extends HTMLAttributes<HTMLTableCellElement> {
  children: ReactNode;
  className?: string;
  scope?: 'col' | 'colgroup' | 'row' | 'rowgroup';
}

export const TableCell: FC<TableCellProps> = ({
  children,
  className = '',
  scope,
  ...props
}) => {
  if (scope) {
    return (
      <th className={className} scope={scope} {...props}>
        {children}
      </th>
    );
  }
  return (
    <td className={className} {...props}>
      {children}
    </td>
  );
};
